import React from "react";
import {
  ServicesContainer,
  LoaderImg,
  RoadmapHeading,
  LoaderImgDiv,
  WhitepaperHeading,
} from "./ServicesElements";
import loaderimg from "../../images/Frame3.png";
import {
  Eggsimg,
  EggsImgCon,
  // Familiesline,
  FamiliesSubtitle,
  FamilyContainer,
  FamilyEvenHeading,
  FamilyHeading,
  Familyimg,
  FamilyInnCont,
  FamilyInnEvenCont,
  ImgEggsDiv,
} from "../Specssection/ServicesElements";
import Group1 from "../../images/Group1.png";
import Group2 from "../../images/Group2.png";
import Group3 from "../../images/Group3.png";
import Group4 from "../../images/Group4.png";
import Frame1 from "../../images/Frame 1.png";
import Frame2 from "../../images/Frame 2.png";
import Frame3 from "../../images/Frame 3.png";
import Frame4 from "../../images/Frame 4.png";
import Frame5 from "../../images/Frame 5.png";
import Frame6 from "../../images/Frame 6.png";

const Services = (props) => {
  return (
    <ServicesContainer id="story">
      <EggsImgCon>
        <ImgEggsDiv>
          <Eggsimg src={Group1} />
        </ImgEggsDiv>
        <LoaderImgDiv>
        <RoadmapHeading>Roadmap</RoadmapHeading>
          <div
            style={{
              width: "50%",
              display: "flex",
              justifyContent: "center",
              // marginBottom: "3rem",
            }}
          >
            <LoaderImg src={loaderimg} />
          </div>
        </LoaderImgDiv>
        <ImgEggsDiv>
          <Eggsimg src={Group4} />
        </ImgEggsDiv>
      </EggsImgCon>
      
     
      <FamilyContainer>
        {/* 1st Member */}

        <FamilyInnCont>
          <Familyimg src={Frame1} />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <FamilyHeading>Pre-Launch</FamilyHeading>
            <FamiliesSubtitle>
              We will hold a super event on our Discord Channel, bringing
              talented artists to talk about art and NFTs. We thought this as a
              great idea to pre-launch our Platform and interact with our
              community to learn more about each other's vision about NFT art on
              blockchain. Follow our accounts to not miss the latest updates!
            </FamiliesSubtitle>
          </div>
        </FamilyInnCont>

        {/* 2nd Member */}
        <FamilyInnEvenCont>
          <Familyimg src={Frame2} />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <FamilyEvenHeading>Presale and Public Sale</FamilyEvenHeading>
            <FamiliesSubtitle style={{ marginLeft: "1rem" }}>
              Our NFTs will be minted onto the blockchain by our supporters
              through our website. We will be opening OpenSea sales soon! Also,
              to the earliest supporters we have thought of airdropping Rare
              Amazing NFTs as a sign of appreciation! Stay tuned for some
              interesting partnerships!
            </FamiliesSubtitle>
          </div>
        </FamilyInnEvenCont>

        {/* 3rd Member */}
        <FamilyInnCont style={{ marginTop: "2rem" }}>
          <Familyimg src={Frame3} />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <FamilyHeading>NFT Reveal</FamilyHeading>
            <FamiliesSubtitle>
              We’ll reveal the tier of your NFT, allowing you to see the
              benefits that you’ll gain from holding. The few selected will see
              some top benefits! Of course, our community wants to contribute
              and the charitable cause will be chosen by you!
            </FamiliesSubtitle>
          </div>
        </FamilyInnCont>

        {/* # 4th Member */}
        <FamilyInnEvenCont>
          <Familyimg src={Frame4} />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <FamilyEvenHeading>Platform accessibility </FamilyEvenHeading>
            <FamiliesSubtitle style={{ marginLeft: "1rem" }}>
              Owners of every tier will be given access to our Platform gaining
              the best knowledge by the best "teachers". You will find exclusive
              merchandise available to our website. Initial spots for our NFT
              holders. Expect some crazy giveaways
            </FamiliesSubtitle>
          </div>
        </FamilyInnEvenCont>

        {/* # 5th Member */}
        <FamilyInnCont style={{ marginTop: "2rem" }}>
          <Familyimg src={Frame5} />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <FamilyHeading>Metaverse</FamilyHeading>
            <FamiliesSubtitle>
              Holders of our NFTs will be given the chance to attend a Mateverse
              Concert for free! Early access to 3500 Unique NFT collections with
              exclusive whitelist spots for holders’ part of our community.
              Partnership with some major brands and more giveaways rewarding
              you with ETH straight to your wallet!
            </FamiliesSubtitle>
          </div>
        </FamilyInnCont>
        <FamilyInnEvenCont style={{ marginTop: "2rem" }}>
          <Familyimg src={Frame6} />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <FamilyEvenHeading>SOLD!</FamilyEvenHeading>
            <FamiliesSubtitle>
              To celebrate our accomplishments, we will create 10 Fascinating
              NFTs and airdrop them to lucky supporters of our platform. A party
              to enjoy our gallery and music! Launching our clubhouse to hang
              out with friends, fans and holders!
            </FamiliesSubtitle>
          </div>
        </FamilyInnEvenCont>
      </FamilyContainer>
      <EggsImgCon>
        <ImgEggsDiv>
          <Eggsimg src={Group2} />
        </ImgEggsDiv>
        <WhitepaperHeading>White Paper</WhitepaperHeading>
        <ImgEggsDiv>
          <Eggsimg src={Group3} />
        </ImgEggsDiv>
      </EggsImgCon>
    </ServicesContainer>
  );
};

export default Services;
